import effectManager from '../effect';
const effect = new effectManager();

export default class Btn{
    constructor(){

        /* 必要なDOM */
        this.$target = $(".js__btn");

        /* 設定 */
        this.conf = {
        }

        /* ステータス */
        this.status = {
        }
    }
    init() {


        effect.btn(this.$target,"set");


        this.$target.on("mouseenter",function () {

            effect.btn($(this),"show","hover");
        }).on("mouseleave",function () {

            effect.btn($(this),"out","hover");
        });

        // $(".js__btn").hover(()=>{
        //     console.log("hey");
        //     effect.btn($(this),"show");
        // },()=>{
        //     effect.btn($(this),"out");
        // });


    }

    resize(){

    }
}